import React, { useEffect, useState } from "react";
import CustomDrawer from "../../UniversalComponents/CustomDrawer";
import { ReactComponent as CrossIcon } from "../../../assets/images/CrossIconCreateGroup.svg";
import Button from "../../UniversalComponents/DefaultButton";

const CreateGroupDrawer = ({ isOpen, onClose, permissionData, data }) => {
  console.log("groupdrawerData", data);

  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
    PermissionLevel: "",
    Views: "",
  });

  useEffect(() => {
    if (data) {
      setFormData((prev) => ({
        ...prev,
        Name: data.group_name,
      }));
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log("name,value", name, value);

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <CustomDrawer open={isOpen} onClose={onClose}>
      <div className="h-full flex flex-col">
        <div className="flex justify-between items-center h-1/12 px-4 py-4 border-b border-[#BECBD3]">
          <div className="text-[16px] font-poppins font-medium capitalize text-[#1D4469]">Create Group</div>
          <div onClick={onClose} className="cursor-pointer">
            <CrossIcon />
          </div>
        </div>
        <form onSubmit={() => {}} className="min-h-0 grow flex flex-col justify-between">
          <div className="min-h-5 p-4">
            {/* name field */}
            <div className="">
              <label htmlFor="name" className="block text-base font-400 text-434852">
                Name <span className="mb-1 text-red-500"></span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.Name}
                onChange={(e) => handleChange(e)}
                placeholder="Enter Subject"
                className="w-full rounded-md text-sm font-400  px-4 py-1 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-500"
                required
              />
            </div>

            {/* description field */}
            <div className="pt-4">
              <label htmlFor="description" className="block text-base font-400 text-434852">
                Description <span className="mb-1 text-red-500"></span>
              </label>
              <textarea
                id="Description"
                name="Description"
                value={formData.Description}
                onChange={(e) => handleChange(e)}
                placeholder="Type Something"
                className="w-full rounded-md text-sm font-400  px-4 py-2 border border-gray-300 focus:outline-none focus:ring-1 focus:ring-gray-500 resize-none"
                rows="4"
                required
              ></textarea>
            </div>

            <div className="pt-4">
              {/* <h3 className="text-[#434852] text-base">Reason</h3> */}
              <label htmlFor="permission level" className="block text-base font-400 text-434852">
                Permission Level <span className="mb-1 text-red-500"> </span>
                {/* {false && <span className="text-red-500"></span>} */}
              </label>
              <select
                id="PermissionLevel"
                name="PermissionLevel"
                value={formData.PermissionLevel}
                onChange={(e) => {
                  handleChange(e);
                }}
                className="w-full rounded-md text-sm font-400  px-4 py-1 cursor-pointer"
                required
              >
                <option value="" disabled>
                  Select a Permission Level
                </option>
                {permissionData?.map((reason, index) => (
                  <option key={index} value={reason.permissionLevel} className="cursor-pointer">
                    {reason.permissionLevel}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="flex justify-end gap-1 p-4 border-t border-[#BECBD3] shadow-md">
            <Button
              onClick={() => {
                onClose();
              }}
            >
              Cancel
            </Button>
            <Button variant={"primary"}>Update</Button>
          </div>
        </form>
      </div>
    </CustomDrawer>
  );
};

export default CreateGroupDrawer;
